import { Spacing } from "@hey-lady/shared/helpers/enum";
import { useFormatMessages } from "@hey-lady/shared/hooks/general";
import newVersion from "@hey-lady/shared/static/images/new-version.png";
import Button from "@hey-lady/ui/atoms/Button";
import { Box, type Theme, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

/**
 * Styles
 */
const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(Spacing.l),
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
    },
  },
  image: {
    width: "400px",
    height: "auto",
    margin: theme.spacing(Spacing.xl, 0),
    [theme.breakpoints.down("sm")]: {
      width: "270px",
    },
  },
}));

export default function NewVersionFallback() {
  const reloadPage = () => {
    window.location.reload();
  };

  const { classes } = useStyles();
  const [heading, description, refresh] = useFormatMessages([
    {
      id: "ERROR_UPDATE_HEADING",
    },
    {
      id: "ERROR_UPDATE_DESCRIPTION",
      values: {
        br: <br />,
      },
    },
    {
      id: "ERROR_UPDATE_REFRESH",
    },
  ]);
  return (
    <Box className={classes.root}>
      <Typography variant="h1" align="center" mb={Spacing.l}>
        {heading}
      </Typography>
      <Box maxWidth={700}>
        <Typography variant="body2" align="center">
          {description}
        </Typography>
      </Box>
      <Box mt={Spacing.ml}>
        <Button variant="contained" onClick={reloadPage}>
          {refresh}
        </Button>
      </Box>
      <img src={newVersion} alt="new version illustration" className={classes.image} />
    </Box>
  );
}
